import React from 'react';

function QuoteRight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M11.13,10.45a5.92,5.92,0,0,1-.68,2.82,9.62,9.62,0,0,1-1.59,2.21A13.26,13.26,0,0,1,6.8,17.21,19.13,19.13,0,0,1,5,18.33l-.8-1.38q1-.56,1.84-1.16a7,7,0,0,0,1.35-1.14,6.46,6.46,0,0,0,1-1.46,5.52,5.52,0,0,0,.47-2H7.73a3.28,3.28,0,0,1-2.3-.75,2.68,2.68,0,0,1-.82-2.09,2.72,2.72,0,0,1,.75-1.82,2.57,2.57,0,0,1,2-.86A3.16,3.16,0,0,1,10.27,7,6.21,6.21,0,0,1,11.13,10.45Zm8.67,0a5.92,5.92,0,0,1-.68,2.82,9.62,9.62,0,0,1-1.59,2.21,13.26,13.26,0,0,1-2.06,1.72,19.13,19.13,0,0,1-1.8,1.11l-.8-1.38q1-.56,1.84-1.16a7,7,0,0,0,1.35-1.14,6.46,6.46,0,0,0,1-1.46,5.52,5.52,0,0,0,.47-2H16.41a3.28,3.28,0,0,1-2.3-.75,2.68,2.68,0,0,1-.82-2.09A2.72,2.72,0,0,1,14,6.53a2.57,2.57,0,0,1,2-.86A3.16,3.16,0,0,1,18.94,7,6.21,6.21,0,0,1,19.8,10.45Z" />
    </svg>
  );
}

export default QuoteRight;



// WEBPACK FOOTER //
// ./src/common/icons/QuoteRight.js